interface LoadingOverlayProps {
  isLoading: boolean;
  children?: React.ReactNode;
}

export function LoadingOverlay({ isLoading, children }: LoadingOverlayProps) {
  return (
    <div className="relative">
      {children}
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-xs">
          <div className="loader" aria-label="Loading" />
        </div>
      )}
    </div>
  );
}
